'use client';

import { useAppSelector } from 'lib/hooks';
import {
  selectIsPlanInCart,
  selectIsPlanRecommended,
  selectIsPlanSaved,
} from 'slices/selectors';
import type { MedicareApiPlan } from 'types/api';

export const usePlanInteractionState = (
  plan: Pick<MedicareApiPlan, 'id' | 'planYear'>
) => {
  const isSaved = useAppSelector((state) => selectIsPlanSaved(state, plan));
  const isInCart = useAppSelector((state) => selectIsPlanInCart(state, plan));
  const isRecommended = useAppSelector((state) =>
    selectIsPlanRecommended(state, plan)
  );

  return { isSaved, isInCart, isRecommended };
};
